<template>
  <a-spin :spinning="loading">
    <div class="app-container">
    <div class="fixedButton">
      <vxe-button v-if="!showSaveBtn" class="examineButton" @click="ReturnFun">返回</vxe-button>
      <vxe-button v-if="!showSaveBtn && showPublish1" status="primary" @click="editFun">编辑</vxe-button>
      <vxe-button v-if="showSaveBtn" class="examineButton" @click="cancelFun">取消</vxe-button>
      <vxe-button v-if="(!showSaveBtn || showPublish) && !activityTimeIsPast" status="success" @click="saveFun(0)">保存</vxe-button>
      <vxe-button v-if="showPublish" v-waves class="examineButton" status="success" @click="saveFun(1)">发布</vxe-button>
    </div>
    <div class="CertificateReleaseApplicationBox scrollBars" :style="`height:${$store.state.app.height - 80}px;`">
      <!--    新增活动VIEW-->
      <!-- <div class="detailsActivity"> -->
      <div class="item-line" style="margin: 0px">活动计划信息</div>
      <div class="budgetBox bodyBox">
        <a-form-model ref="activityForm" class="UniformCss" :inline="true" :model="activity" :rules="rules" label-width="100px">
          <a-row>
            <a-col :span="12">
              <a-form-model-item label="市场活动来源" prop="selectedOrgText">
                <a-select ref="selectOrgPopup" v-model="selectedOrgText" class="sourceSelect" placeholder="选择活动来源" :disabled="editDisabled" @click.native="showTree" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <!-- <a-col :span="6">
              <a-form-model-item label="一级来源">
                <a-input v-model="activity.oneLevelName" disabled />
              </a-form-model-item>
            </a-col>
            <a-col :span="6">
              <a-form-model-item label="二级来源">
                <a-input v-model="activity.twoLevelName" disabled />
              </a-form-model-item>
            </a-col>
            <a-col :span="6">
              <a-form-model-item label="三级来源" :disabled="true">
                <a-input v-model="activity.threeLevelName" disabled />
              </a-form-model-item>
            </a-col> -->
            <!-- <a-col :span="6">
              <a-form-model-item label="四级来源" :disabled="true">
                <a-input v-model="activity.fourLevelName" disabled />
              </a-form-model-item>
            </a-col>
            <a-col :span="6">
              <a-form-model-item label="五级来源" :disabled="true">
                <a-input v-model="activity.fiveLevelName" disabled />
              </a-form-model-item>
            </a-col> -->
            <!-- <a-col :span="6">
              <a-form-model-item label="归属分类" :disabled="true">
                <a-input v-model="classType.sourceClass" :disabled="true" />
              </a-form-model-item>
            </a-col>
            <a-col :span="6">
              <a-form-model-item label="来源分类" :disabled="true">
                <a-input v-model="classType.belongClass" :disabled="true" />
              </a-form-model-item>
            </a-col> -->
          <!-- </a-row>
          <a-row> -->
            <a-col :span="6">
              <a-form-model-item label="活动名称" prop="actName">
                  <a-input v-model="activity.actName" disabled />
              </a-form-model-item>
            </a-col>
            <!-- <a-col :span="6">
              <a-form-model-item label="预算类型" prop="budgetTypeCode">
                <a-input v-model="activity.budgetTypeName" disabled />
              </a-form-model-item>
            </a-col> -->
            <a-col :span="6">
              <a-form-model-item label="政策立项编号" prop="projectCode">
                <a-input v-model="activity.projectCode" :disabled="editDisabled" />
              </a-form-model-item>
            </a-col>
            <!-- <a-col :span="6">
              <a-form-model-item label="计划编码">
                <a-input v-model="activity.planCode" disabled />
              </a-form-model-item>
            </a-col> -->
            <a-col :span="6">
              <a-form-model-item label="生效时间" prop="planStartTime">
                <a-date-picker v-model="activity.planStartTime" type="date"  :format="dateFormat"
                :value-format="'YYYY-MM-DD HH:mm:ss'" :disabled="editDisabled" />
              </a-form-model-item>
            </a-col>
            <a-col :span="6">
              <a-form-model-item label="失效时间" prop="planEndTime">
                <a-date-picker v-model="activity.planEndTime" type="date"  :format="dateFormat"
                :value-format="'YYYY-MM-DD HH:mm:ss'"  :disabled-date="disabledTime" :disabled="activityTimeIsPast" />
              </a-form-model-item>
            </a-col>
            <!-- <a-col :span="6">
              <a-form-model-item label="类型">
                <a-input :value="activity.type == 0 ? '大区' : '总部'" disabled />
              </a-form-model-item>
            </a-col>
            <a-col :span="6">
              <a-form-model-item label="状态">
                <a-input :value="activity.planStatus == 0 ? '待发布' : '已发布'" disabled />
              </a-form-model-item>
            </a-col> -->
          </a-row>
          <!-- <a-row>
            <a-col v-if="activity.strainsCarName" :span="12">
              <a-form-model-item label="执行车系" class="act-item">
                <a-input v-model="activity.strainsCarName" readonly @click.native="onShowCarSeries" />
              </a-form-model-item>
            </a-col>
            <a-col v-else :span="12">
              <a-form-model-item label="执行车系" class="act-item">
                <a-input v-model="emptyText" disabled />
              </a-form-model-item>
            </a-col>
          </a-row> -->
          <a-row>
            <a-col :span="18" style="height: auto">
              <a-form-model-item label="其他说明" prop="remarks">
                <el-input
                  v-model="activity.remarks"
                  type="textarea"
                  disabled
                  style="width: 100%"
                  maxlength="400"
                  show-word-limit
                  :autosize="{ minRows: 4, maxRows: 6 }"
                />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </div>
      <div class="item-line" style="margin: 0px">核销信息</div>
      <div class="budgetBox bodyBox">
        <a-form-model>
          <div style="margin-left: 2%">
            <a-form-model-item label="核销规则描述" style="margin-bottom: 5px">
              <el-input
                v-model="activity.writeOffRules"
                type="textarea"
                style="width: 80%"
                :disabled="editDisabled"
                maxlength="400"
                show-word-limit
                :autosize="{ minRows: 4, maxRows: 6 }"
              />
            </a-form-model-item>
            <a-form-model-item label="核销材料说明" style="margin-bottom: 5px">
              <el-input
                v-model="activity.writeOffMaterial"
                type="textarea"
                style="width: 80%"
                :disabled="editDisabled"
                maxlength="400"
                show-word-limit
                :autosize="{ minRows: 4, maxRows: 6 }"
              />
            </a-form-model-item>
            <a-form-model-item label="核销其他说明">
              <el-input
                v-model="activity.writeOffOther"
                type="textarea"
                style="width: 80%"
                :disabled="editDisabled"
                maxlength="400"
                show-word-limit
                :autosize="{ minRows: 4, maxRows: 6 }"
              />
            </a-form-model-item>
          </div>
        </a-form-model>
      </div>
      <div class="item-line" style="margin: 0px">下发对象及费用额度标准</div>
      <div class="budgetBox bodyBox">
        <div style="padding-bottom: 5px; margin-left: 1%; display: flex">
          <a-form-model style="display:flex;flex-wrap: wrap;" class="select-form">
            <a-space>
              <a-form-model-item label="经销商名称" style="margin: 10px">
                <a-input v-model="conditions.dealerName" style="width: 200px" placeholder="请输入经销商名称" @keyup.enter.native="queryByPageActDb" />
              </a-form-model-item>
              <a-form-model-item label="经理部" style="margin: 10px">
                <a-select v-model="conditions.sectorId" placeholder="请选择经理部" style="width: 120px">
                  <a-select-option label="全部" :value="null" >全部</a-select-option>
                  <a-select-option v-for="item in sectorList" :key="item.deptId" :value="item.deptId">{{item.deptName}}</a-select-option>
                </a-select>
              </a-form-model-item>
              <a-form-model-item label="省" style="margin: 10px">
                <a-select v-model="conditions.provinceId" placeholder="请选择省" style="width: 150px" @change="changeProvince">
                  <a-select-option label="全部" :value="null" >全部</a-select-option>
                  <a-select-option v-for="item in provinceList" :key="item.provinceId" :value="item.provinceCode" >{{item.provinceName}}</a-select-option>
                </a-select>
              </a-form-model-item>
              <a-form-model-item label="城市" style="margin: 10px">
                <a-select v-model="conditions.cityId" placeholder="城市" style="width: 150px">
                  <a-select-option v-for="item in cityList" :key="item.cityId" :value="item.cityCode" >{{item.cityName}}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-space>
          </a-form-model>
        </div>
        <div>
          <vxe-button status="primary" @click="queryByPageActDb">搜索</vxe-button>
          <vxe-button status="info" @click="clearData1">重置</vxe-button>
          <vxe-button v-waves :loading="dealerAddBtnLoading" status="primary" @click="goDistributorList" :disabled="activityTimeIsPast">添加</vxe-button>
          <vxe-button status="primary" @click="uploadFun">导入商家</vxe-button>
          <vxe-button status="primary" @click="editExecuteFreqDialog" :disabled="activityTimeIsPast">批量修改频次</vxe-button>
        </div>
        <div>
          <el-form ref="modelTableBaseFormRef" :model="modelTableBase" label-width="14px">
            <vxe-table
            v-loading="modelTableBase.loading"
            border
            align="center"
            show-header-overflow
            show-overflow
            class="mytable-scrollbar tableOvf"
            :column-config="{ resizable: true }"
            stripe
            round
            style="margin-top: 10px"
            :max-height="$store.state.app.height - 300 > 200 ? $store.state.app.height - 200 : 200"
            :scroll-y="{ enabled: false }"
            :row-config="{ isHover: true }"
            :data="pageSelectedDealers"
            @checkbox-change="handleDealerSelectionChange"
            @checkbox-all="handleDealerSelectionChange"
          >
            <vxe-column type="checkbox" width="60" align="center" />
            <vxe-column type="seq" title="序号" width="60" align="center" />
            <vxe-column title="经理部" field="sectorName" width="150" />
            <vxe-column title="经销商名称" field="dealerName" width="200" />
            <!-- <vxe-column title="地址" field="address" width="180" /> -->
<!--            <vxe-column title="费用额度(元)" field="feeLimit" width="200" align="right">-->
<!--              <template #default="{ row }">-->
<!--                {{ row.feeLimit | toThousandNumFilter }}-->
<!--              </template>-->
<!--            </vxe-column>-->
<!--            <vxe-column title="核销比例(%)" field="writeRate" />-->
<!--            <vxe-column title="执行频次" field="executeFreq" />-->
            <vxe-column title="费用额度(元)">
              <template #default="scope">
                <el-form-item label=" " :prop="'data.' + (scope.seq - 1) + '.feeLimit'" :rules="[{ required: true, message: '请输入费用额度!', trigger: 'blur' }]">
                  <a-input v-model="scope.row.feeLimit" placeholder="请输入" oninput="value=value.replace(/\D/g, '')" :disabled="!!scope.row.id"/>
                </el-form-item>
              </template>
            </vxe-column>
            <vxe-column title="核销比例(%)">
              <template scope="scope">
                <el-form-item label=" " :prop="'data.' + (scope.seq - 1) + '.writeRate'" :rules="[{ required: true, message: '请输入核销比例!', trigger: 'blur' }]">
                  <a-input v-model="scope.row.writeRate" placeholder="请输入" @input="handleWriteRateInput(scope.row, 'writeRate')" :disabled="!!scope.row.id"/>
                </el-form-item>
              </template>
            </vxe-column>
            <vxe-column title="执行频次">
              <template scope="scope">
                <el-form-item label=" " :prop="'data.' + (scope.seq - 1) + '.executeFreq'" :rules="[{ required: true, message: '请输入执行频次!', trigger: 'blur' }]">
                  <a-input v-model="scope.row.executeFreq" placeholder="请输入" @input="e => scope.row.executeFreq = e.target.value.replace(/[^\d]/g, '')" :disabled="!!scope.row.id && activityTimeIsPast"/>
                </el-form-item>
              </template>
            </vxe-column>
            <!-- <vxe-column title="集客目标" field="customerTarget" width="100" />
            <vxe-column title="订单目标" field="orderTarget" width="100" />
            <vxe-column title="执行数量" field="executeNum" width="100" />
            <vxe-column title="关闭时间" field="closeTime" width="160" /> -->
            <vxe-column v-if="activity.planStatus === '1'" title="操作" width="170" fixed="right" align="center">
              <template #default="{ row }">
                <div class="handle-box">
                  <a-button type="link" v-if="row.id" icon="el-icon-edit" @click="editDlrFun(row)">编辑</a-button>
                  <a-button type="link" icon="el-icon-delete" @click="deleteFun(row)">删除</a-button>
                </div>
              </template>
            </vxe-column>
          </vxe-table>
          </el-form>
          <vxe-pager
            v-show="!modelTableBase.loading"
            :current-page="pagination.current"
            :page-size="pagination.size"
            :total="pagination.total"
            :page-sizes="[10, 15, 20, 50, 100]"
            :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
            @page-change="changePage"
          />
        </div>
      </div>
    </div>
    <a-modal title="选择三级来源" :visible.sync="showTreeDialog" center width="40%" @cancel="handleDialogCancel">
      <FiveSourceTree v-if="showTreeDialog" ref="sourceTree" :tree-data="treeData" :check-key="checkKey" />
      <span slot="footer" class="dialog-footer">
        <vxe-button @click="handleDialogCancel">取 消</vxe-button>
        <vxe-button type="primary" @click="handleDialogConfirm">确 定</vxe-button>
      </span>
    </a-modal>
    <!--导入对话框 -->
    <a-modal title="导入Excel" :visible.sync="uploadDialog" width="400px" @cancel="()=>uploadDialog=false" :footer="null">
      <div v-loading="importLoading" class="faultAdd">
        <div class="model-box">
          <!-- <a class="load-buttom" href="/file/活动下发对象导入模板v2.xlsx" download><i class="el-icon-download" />下载示例模板</a> -->
          <a class="load-buttom" @click="downloadTemplate"><i class="el-icon-download" />下载示例模板</a>
        </div>
        <el-upload ref="upload" class="upload-demo" drag action="" multiple :http-request="upload" :before-upload="uploadBefore" :file-list="fileList">
          <i class="el-icon-upload" />
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div slot="tip" class="el-upload__tip">直接导入已填好的Excel列表，仅支持XLS/XLSX</div>
        </el-upload>
        <div v-if="errorList.length > 0" class="err-box">
          <el-link icon="el-icon-warning" type="danger">Excel导入出错，请检查错误行，然后将错误行重新导入</el-link>
          <div v-for="item in errorList" :key="item.row">
            <el-link type="danger">第{{ item.row }}行{{ item.error }}</el-link>
          </div>
        </div>
      </div>
    </a-modal>
    <a-modal title="执行车系" :visible.sync="showCarSeries" width="40%" @cancel="()=>showCarSeries = false">
      <vxe-table
        ref="xTable"
        border
        class="mytable-scrollbar"
        show-header-overflow
        show-overflow
        :column-config="{ resizable: true }"
        stripe
        round
        style="margin-top: 10px"
        :max-height="$store.state.app.height - 350 < 185 ? 185 : $store.state.app.height - 350"
        :scroll-y="{ enabled: false }"
        :row-config="{ isHover: true }"
        :data="carStrainList"
      >
        <vxe-column type="seq" title="序号" width="60" align="center" />
        <vxe-column title="品系" field="strains" align="center" />
        <vxe-column title="车系" field="carSeries" align="center" />
      </vxe-table>
      <span slot="footer" class="dialog-footer">
        <vxe-button @click="showCarSeries = false">关 闭</vxe-button>
      </span>
    </a-modal>
    <a-modal title="编辑" :visible.sync="editDialog" width="30%" @cancel="editCancel">
      <a-form-model ref="editDealerForm" :inline="true" class="UniformCss" :model="editData" :rules="dealerRules" label-width="100px">
        <a-row>
          <a-col>
            <a-form-model-item label="经销商:">
              <a-input
                v-model="editData.dealerName"
                disabled
              />
            </a-form-model-item>
          </a-col>
          <a-col>
            <a-form-model-item label="费用额度(元):" prop="feeLimit">
              <a-input
                v-model="editData.feeLimit"
                placeholder="费用额度"
                clearable
                oninput="value=value.replace(/[^\d]/g, '')"
              />
            </a-form-model-item>
          </a-col>
          <a-col>
            <a-form-model-item label="核销比例(%):" prop="writeRate">
              <a-input
                v-model="editData.writeRate"
                placeholder="核销比例"
                clearable
                @input="handleWriteRateInput()"
              />
            </a-form-model-item>
          </a-col>
          <a-col>
            <a-form-model-item label="执行频次:" prop="executeFreq">
              <a-input
                v-model="editData.executeFreq"
                placeholder="执行频次"
                clearable
                oninput="value=value.replace(/[^\d]/g, '')"
              />
            </a-form-model-item>
          </a-col>
          <!-- <a-col>
            <a-form-model-item label="集客目标:">
              <a-input
                v-model="editData.customerTarget"
                placeholder="集客目标"
                clearable
                oninput="value=value.replace(/[^\d]/g, '')"
              />
            </a-form-model-item>
          </a-col>
          <a-col>
            <a-form-model-item label="订单目标:">
              <a-input
                v-model="editData.orderTarget"
                placeholder="订单目标"
                clearable
                oninput="value=value.replace(/[^\d]/g, '')"
              />
            </a-form-model-item>
          </a-col>
          <a-col>
            <a-form-model-item label="执行数量:">
              <a-input
                v-model="editData.executeNum"
                placeholder="执行数量"
                clearable
                oninput="value=value.replace(/[^\d]/g, '')"
              />
            </a-form-model-item>
          </a-col>
          <a-col>
            <a-form-model-item label="关闭时间:">
              <a-date-picker
                v-model="editData.closeTime"
                type="date"
                 :format="dateFormat"
                 :value-format="'YYYY-MM-DD HH:mm:ss'"
                placeholder="选择时间"
              />
            </a-form-model-item>
          </a-col> -->
        </a-row>
      </a-form-model>
      <span slot="footer" class="dialog-footer">
        <vxe-button @click="editCancel">取 消</vxe-button>
        <vxe-button status="primary" @click="editConfirm">确 定</vxe-button>
      </span>
    </a-modal>

    <!--    添加经销商列表-->
    <el-dialog title="添加经销商列表" :visible.sync="dealerAddDialogVisible" width="80%" :before-close="handleDealerAddDialogBeforeClose">
      <div class="usereq">
        <div>
          <el-form :inline="true" style="margin: 0px; height: auto; padding: 0px 10px; vertical-align: middle">
            <SiftDealer :base="base">
              <template slot="ButtonTwo">
                <el-form-item style="margin: 10px">
                  <vxe-button style="background: #1b81ef; border: 0px" status="primary"  @click="handleQueryByPageInDealerAddDialog(1)">搜索</vxe-button>
                  <vxe-button  @click="handleClearDataInDealerAddDialog">重置</vxe-button>
                </el-form-item>
              </template>
            </SiftDealer>
          </el-form>
        </div>
        <a-row :gutter="1">
          <a-col :span="12">
            <div class="left_content">
              <vxe-table
                  ref="table1"
                  v-loading="dealerAddPageDataSearchLoading"
                  border
                  class="mytable-scrollbar"
                  show-header-overflow
                  show-overflow
                  :column-config="{ resizable: true }"
                  stripe
                  round
                  style="margin-top: 10px"
                  max-height="370"
                  :scroll-y="{ enabled: false }"
                  :row-config="{ isHover: true }"
                  :data="dealerAddDialogAllDealerList"
                  :checkbox-config="checkboxConfigInDealerAddDialog"
                  @checkbox-change="handleCheckedLeftChange($event.records)"
                  @checkbox-all="handleCheckedLeftChange($event.records)"
              >
                <vxe-column type="checkbox" width="60" align="center" />
                <vxe-column type="seq" title="序号" width="60" align="center" />
                <vxe-column title="经理部" field="sectorName" width="100" />
                <vxe-column title="经销商名称" field="dealerName"/>
              </vxe-table>
            </div>
          </a-col>
          <a-col :span="1">
            <div class="move-btn-container">
              <vxe-button type="primary" icon="el-icon-arrow-right" circle @click="putDealerDataToRight()" />
              <vxe-button style="margin: 20px 0 0 0" type="primary" icon="el-icon-arrow-left" circle @click="putDealerDataToLeft()" />
            </div>
          </a-col>
          <a-col :span="11">
            <div class="left_content">
              <vxe-table
                  ref="table2"
                  v-loading="dealerAddPageDataSearchLoading"
                  border
                  class="mytable-scrollbar"
                  show-header-overflow
                  show-overflow
                  :column-config="{ resizable: true }"
                  stripe
                  round
                  style="margin-top: 10px"
                  max-height="370"
                  :scroll-y="{ enabled: false }"
                  :row-config="{ isHover: true }"
                  :data="dealerAddDialogSelectedDealerList"
                  @checkbox-change="rhandleCheckedLeftChange($event.records)"
                  @checkbox-all="rhandleCheckedLeftChange($event.records)"
              >
                <vxe-column type="checkbox" width="60" align="center" />
                <vxe-column type="seq" title="序号" width="60" align="center" />
                <vxe-column title="经理部" field="sectorName" width="100" />
                <vxe-column title="经销商名称" field="dealerName" />
              </vxe-table>
            </div>
          </a-col>
        </a-row>
        <div class="footer-btn-box">
          <vxe-button @click="handleDealerAddDialogBeforeClose">关闭</vxe-button>
          <vxe-button status="primary" @click="submitDistributorSelect">确认</vxe-button>
        </div>
      </div>
    </el-dialog>
      <a-modal title="批量修改执行频次" :visible.sync="editExecuteFreqVisible" width="30%" @cancel="editExecuteFreqVisible = false">
        <a-form-model :inline="true" class="UniformCss" label-width="100px">
          <a-form-model-item label="执行频次:">
            <a-input
                v-model="newExecuteFreq"
                placeholder="执行频次"
                clearable
                oninput="value=value.replace(/[^\d]/g, '')"
            />
          </a-form-model-item>
        </a-form-model>
        <span slot="footer" class="dialog-footer">
         <vxe-button @click="editExecuteFreqVisible = false">取 消</vxe-button>
         <vxe-button status="primary" @click="editBatchExecuteFreq" :loading="editBatchExecuteFreqLoading">确 定</vxe-button>
        </span>
      </a-modal>
  </div>
  </a-spin>
</template>

<script>
import waves from '@/directive/waves' // waves directive
import {
  findById,
  findPlanDealers,
  publishActPlan,
  updateAfterPublish,
  updateCloseTime,
  removePlanDealer,
  getClassByCode,
  exportActPlanTemp,
  uploadPlanDealer,
  batchUpdateExecuteFreq, saveBatchInDetails
} from '@/api/actPlan'
import { getOrganizationList } from '@/api/activity.js'
import {findProvince, findCity, findSectorJinLiList, findDealerList} from '@/api/base-data'
import FiveSourceTree from './components/FiveSourceTree/index.vue'
import moment from 'moment';
import SiftDealer from "@/pages/web/terminalActivity/components/SiftDealer.vue";
import {toThousandNumFilter} from "@/filters";

const defaultActivity = {
  id: '',
  actName: '', // 活动名称
  budgetTypeCode: '', // 预算类型编码
  budgetTypeName: '',
  oneLevelCode: '', // 一级来源编码
  oneLevelName: '',
  twoLevelCode: '', // 二级来源编码
  twoLevelName: '',
  threeLevelCode: '', // 三级来源编码
  threeLevelName: '',
  fourLevelCode: '', // 四级来源编码
  fourLevelName: '',
  fiveLevelCode: '', // 五级来源编码
  fiveLevelName: '',
  planStatus: 0, // 活动计划状态:0待发布，1已发布，2已失效
  planStartTime: '', // 计划生效时间
  planEndTime: '', // "计划失效时间/计划结束时间
  type: 1, // 计划类型 0大区-区域基金 1总部
  planCode: '', // 活动编码
  remarks: '', // 备注
  writeOffAnnex: '',
  writeOffInvoices: ''
}

export default {
  name: 'DetailsActivity',
  // inject: ['reload'],
  directives: { waves },
  components: {
    SiftDealer,
    FiveSourceTree
  },
  data() {
    return {
      // selectedOrgText: null,
      rules: {
        planStartTime: [{ required: true, message: '请选择生效时间', trigger: 'blur' }],
        planEndTime: [{ required: true, message: '请选择失效时间', trigger: 'blur' }],
        projectCode: [{ required: true, message: '请输入政策立项编号', trigger: 'blur' }],
        selectedOrgText: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!this.selectedOrgText) {
                callback(new Error('请选择活动来源'))
                return
              }
              callback()
            },
            trigger: 'blur'
          }
        ]
      },
      dealerRules: {
        feeLimit: [{ required: true, message: '请输入费用额度', trigger: 'blur' }],
        writeRate: [{ required: true, message: '请输入核销比例', trigger: 'blur' }],
        executeFreq: [{ required: true, message: '请输入执行频次', trigger: 'blur' }]
      },
      conditions: {
        dealerName: null,
        sectorId: null,
        provinceId: null,
        cityId: null
      },
      strDate: {
        planstarttimesham: null,
        planendtimesham: null
      },
      activity: Object.assign({}, defaultActivity),
      modelTableBase: {
        data: [],
        loading: false,
        selection: []
      },
      pagination: {
        total: 0,
        size: 10,
        current: 1
      },
      sectorList: [],
      provinceList: [],
      cityList: [],
      uploadDialog: false,
      importLoading: false,
      fileList: [],
      errorList: [],
      showPublish: false,
      showPublish1: false,
      loading: false,
      editDialog: false,
      editData: {},
      emptyText: '无',
      carStrainList: [],
      showCarSeries: false,
      showSaveBtn: false,
      editDisabled: true,
      showTreeDialog: false,
      treeProps: {
        label: 'sourceName',
        children: 'children'
      },
      sourceData: [
        {
          sourceCode: 'default',
          parentNodeId: 'A',
          sourceName: '活动来源',
          enableSelect: '0',
          children: []
        }
      ],
      treeData: [],
      selectData: {},
      classType: {},
      dateFormat: 'YYYY-MM-DD HH:mm:ss',
      dealerAddBtnLoading: false,
      dealerAddDialogVisible: false,
      dealerAddDialogAllDealerList: [], // （弹出框）经销商列表,经销商添加页面全部经销商列表
      dealerAddDialogSelectedDealerList: [], // （弹出框）已选经销商列表，经销商添加页面已经选择的经销商列表
      base: {      // 经销商添加对话框中的查询条件对应数据
        sectorId: null,
        provinceId: null,
        cityId: null,
        dealerName: null
      },
      checkboxConfigInDealerAddDialog: {
        checkMethod: ({ row }) => {
          return !this.dealerAddDialogSelectedDealerList.some(i => row.dealerId === i.dealerId)
        }
      },
      dealerAddPageDataSearchLoading: false,  // 添加页面经销商查询时的loading
      dealerSelectedList: [],  // 详情页主页面中已选择的经销商列表
      editExecuteFreqVisible: false,  // 批量修改批次的对话框控制
      newExecuteFreq: 0,   // 新设置的批量修改的频次
      editBatchExecuteFreqLoading: false, // 批量修改频次界面loading

      pageSelectedDealers: [],  // 当前主页面表格真正展示的当前页数据
    }
  },
  computed: {
    selectedOrgText() {
      return this.activity.oneLevelName + '/' +
                             this.activity.twoLevelName + '/' +
                             this.activity.threeLevelName //+ '/' +
                            //  this.activity.fourLevelName + '/' +
                            //  this.activity.fiveLevelName
    },
    checkKey() {
      return this.activity.fiveLevelCode
    },
    activityTimeIsPast() {
      // 判断活动是否过期
      if (!this.activity.planEndTime) return false
      return moment(this.activity.planEndTime)
          .isSameOrBefore(moment().startOf('day'))
    }
  },
  watch: {
  },
  created() {
    this.activity.id = this.$route.params.id

    if (this.$route.params.id) {
      this.getActById() // 获取活动
      this.queryByPageActDb() // 获取参与活动经销商数据
    }
    if (this.$route.params.state === 'publish') {
      this.showPublish = true
    }
    this.getSectorList()
    this.findProvince()
  },
  methods: {
    toThousandNumFilter,
    clearData1() {
      this.conditions.dealerName = null
      this.conditions.provinceId = null
      this.conditions.cityId = null
      this.conditions.sectorId = null
      this.queryByPageActDb()
    },
    getActById() {
      this.loading = true
      const id = this.activity.id
      findById(id).then(res => {
        if (res.code === 1 && res.data) {
          this.activity = res.data
          this.findClassByCode(this.activity.fiveLevelCode)
          this.loading = false
        } else {
          this.$message.error(res.message)
        }
      })
    },
    uploadFun() {
      this.uploadDialog = true
    },
    findClassByCode(code) {
      getClassByCode(code).then(res => {
        if (res.code === 1 && res.data) {
          this.classType = res.data
        } else {
          // this.$message.error(res.message)
        }
      })
    },
    onShowCarSeries() {
      // 使用逗号分割字符串
      const stringArray = this.activity.strainsCarName.split(',')
      // 创建一个数组来存放对象
      const objectArray = []
      // 遍历分割后的字符串数组，并将每个元素转换为对象
      stringArray.forEach(function(item) {
        var parts = item.split('-') // 使用短横线分割每个元素
        if (parts.length === 2) {
          var obj = {
            strains: parts[0],
            carSeries: parts[1]
          }
          objectArray.push(obj)
        }
      })
      this.carStrainList = objectArray
      this.showCarSeries = true
    },
    showTree() {
      this.showTreeDialog = false
      this.$refs.selectOrgPopup.blur()
    },
    handleDialogCancel() {
      this.$refs.sourceTree.$refs.tree.setCheckedKeys([this.activity.fiveLevelCode])
      this.showTreeDialog = false
    },
    handleDialogConfirm() {
      this.selectData = this.$refs.sourceTree.selectData
      Object.assign(this.activity, this.selectData)
      this.findClassByCode(this.activity.fiveLevelCode)
      this.showTreeDialog = false
    },
    // 下载导入模板
    downloadTemplate() {
      exportActPlanTemp({ tempType: '1' }).then(val => {
        this.$exportExcelData(val, '活动下发对象导入模板.xlsx')
      })
    },
    // 上传前对文件的大小的判断
    uploadBefore(file) {
      const extension = file.name.substring(file.name.lastIndexOf('.') + 1)
      const size = file.size / 1024 / 1024
      if (extension !== 'xlsx' && extension !== 'xls') {
        this.$message('只能上传后缀是.xlsx或者.xls的文件')
        return false
      }

      if (size > 10) {
        this.$message('文件大小不得超过10M')
        return false
      }
    },
    // 上传
    upload(file) {
      const formData = new FormData()
      formData.append('file', file.file)
      formData.append('planId', this.activity.id)
      formData.append('isPublish', '1')
      this.importLoading = true
      uploadPlanDealer(formData).then(res => {
        this.importLoading = false
        if (res.code === 1) {
          this.$message.success('导入成功')
          this.$refs.upload.clearFiles()
          this.importLoading = false
          this.uploadDialog = false
          this.errorList = []
          this.queryByPageActDb()
          // this.reload()
        } else {
          this.errorList = res.data
          this.importLoading = false
          this.$message.error(res.message)
        }
      })
    },
    // 获取五级来源
    getFiveLevelSource() {
      getOrganizationList().then(res => {
        if (res.code === 1) {
          this.sourceData[0].children = res.data
          this.treeData = this.formatData(this.sourceData)
        }
      })
    },
    // 树形数据初始化，外层节点添加disabled
    formatData(params) {
      const data = params
      data.forEach((item) => {
        if (item.children.length !== 0) {
          item.disabled = true
          this.formatData(item.children)
        }
      })
      return data
    },
    queryByPageActDb() {
      this.modelTableBase.loading = true
      this.modelTableBase.data = []
      const data = {
        page: 1,
        limit: 9999,
        planId: this.activity.id,
        ...this.conditions
      }
      findPlanDealers(data).then(res => {
        if (res.code === 1) {
          this.modelTableBase.data = res.data.list
          this.pagination.total = res.data.total
          this.modelTableBase.loading = false
          this.slicePlanDealers()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    changePage({ currentPage, pageSize }) {
      this.pagination.current = currentPage
      this.pagination.size = pageSize
      this.slicePlanDealers();
    },
    submint() {
      // 必须有一条
      if (this.modelTableBase.data < 1) {
        this.$message.error('下发经销商不能为空！')
        return
      }
      this.loading = true
      const data = Object.assign({}, this.activity)
      publishActPlan(data).then(res => {
        if (res.code === 1) {
          this.loading = false
          this.$message.success('发布成功')
          this.ReturnFun()
        } else {
          this.loading = false
          this.$message.error(res.message)
        }
      })
    },
    // 返回
    ReturnFun() {
      this.$closePage('/terminalActivity/detailsActivity', '/terminalActivity/planDelivery')
    },
    // 获取省份
    findProvince() {
      findProvince().then(res => {
        if (res.code === 1 && res.data) {
          this.provinceList = res.data
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 获取经理部
    getSectorList() {
      findSectorJinLiList().then(res => {
        if (res.deptVOList) {
          this.sectorList = res.deptVOList
        }
      })
    },
    changeProvince() {
      if (this.conditions.provinceId) {
        this.findCity(this.conditions.provinceId)
      } else {
        this.base.cityId = null
        this.cityList = []
      }
    },
    // 获取市区
    findCity(id) {
      this.conditions.cityId = null
      findCity({ provinceId: id }).then(res => {
        if (res.code === 1 && res.data) {
          this.cityList = res.data
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 编辑计划信息
    editFun() {
      this.getFiveLevelSource()
      localStorage.setItem('activityEditForm', JSON.stringify(this.activity))
      localStorage.setItem('classType', JSON.stringify(this.classType))
      this.showSaveBtn = true
      this.editDisabled = false
    },
    // 取消计划信息编辑
    cancelFun() {
      this.activity = JSON.parse(localStorage.getItem('activityEditForm'))
      this.classType = JSON.parse(localStorage.getItem('classType'))
      this.showSaveBtn = false
      this.editDisabled = true
    },
    // 保存计划信息
    saveFun(type) {
      // type 为0是保存，为1是发布
      this.$refs['activityForm'].validate((validate) => {
        if (!validate) {
          this.$message.error('完善必填项！')
          return
        }
        if (this.classType.belongClassCode === 'CJ') {
          this.$message('来源分类只能为终端类，请重新选择活动来源')
          return
        }
        this.$refs['modelTableBaseFormRef'].validate(val => {
          if (!val) {
            this.$message.error('完善必填项！')
            return
          }
          if (this.modelTableBase.data < 1) {
            this.$message.error('下发经销商不能为空！')
            return
          }
          this.loading = true
          const data = Object.assign({}, this.activity)
          updateAfterPublish(data).then(res => {
            if (res.code === 1) {
              this.showSaveBtn = false
              this.editDisabled = true
              this.addAndUpdateBatchActplanDealer(type)
              // this.$message.success('修改成功')
              // this.getActById()
            } else {
              this.loading = false
              this.$message.error(res.message)
            }
          })
        })
      })
    },
    // 编辑经销商信息
    editDlrFun(row) {
      this.editData = { ...row }
      this.editDialog = true
    },
    editCancel() {
      this.editDialog = false
    },
    editConfirm() {
      this.$refs['editDealerForm'].validate((validate) => {
        if (!validate) {
          this.$message.error('完善必填项！')
          return
        }
        updateCloseTime(this.editData).then(res => {
          if (res.code === 1) {
            this.$message.success('修改成功')
            this.editDialog = false
            this.queryByPageActDb()
          } else if (res.code === 2) {
            this.$message.warning(res.message)
            this.editDialog = false
            this.queryByPageActDb()
          } else {
            this.$message.error(res.message)
          }
        })
      })
    },
    deleteFun(row) {
      this.$confirm({
        title: '删除活动下发对象',
        content: '此操作将永久删除该活动对象, 是否继续?',
        onOk:() => {
          if (row.id === null || row.id === undefined || row.id === '') {
            this.modelTableBase.data = this.modelTableBase.data.filter(item => item.dealerId !== row.dealerId)
          } else {
            removePlanDealer(row.id).then(res => {
              if (res.code === 1) {
                this.$message.success('删除成功')
                this.queryByPageActDb()
              } else {
                this.$message.error(res.message)
              }
            })
          }
        },
        onCancel:() => {
          this.$message.info('已取消删除')
        },
      });
    },
    handleWriteRateInput(row, field) {  // 处理输入的核销比例，不能超过100
      let val = String(row[field] ?? '')
      val = val.replace(/[^\d]/g, '')   // 只留数字
      if (val && Number(val) > 100) val = '100'
      row[field] = val
    },
    disabledTime(current) {
      // 只能选当前时间的后面时间
      // return current && current < moment(this.activity.planStartTime);
      return current && current < moment().startOf('day');
    },
    // 经销商列表
    goDistributorList() {
      if (!this.activityTimeIsPast){
        this.dealerAddBtnLoading = true
        setTimeout(() => {
          this.dealerAddBtnLoading = false
          this.dealerAddDialogVisible = true
          // 改为获取全部数据
          this.dealerAddDialogSelectedDealerList = this.modelTableBase.data
          this.handleQueryByPageInDealerAddDialog(1)
        }, 200)
      } else {
        this.$message.warning('该活动已过截止时间')
      }
    },
    // 左边经销商列表勾选时触发
    handleCheckedLeftChange(v) {
      this.checkedleft = v
      const checkedCount = v.length
      this.checkAll = checkedCount === this.dealerAddDialogAllDealerList.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.dealerAddDialogAllDealerList.length
    },
    // 右边经销商列表勾选时触发
    rhandleCheckedLeftChange(v) {
      this.rcheckedleft = v
      const checkedCount = v.length
      this.rcheckAll = checkedCount === this.dealerAddDialogSelectedDealerList.length
      this.risIndeterminate = checkedCount > 0 && checkedCount < this.dealerAddDialogSelectedDealerList.length
    },
    // 将经销商数据加到右边
    putDealerDataToRight() {
      this.dealerAddDialogSelectedDealerList = this.handleConcatArr(this.dealerAddDialogSelectedDealerList, this.checkedleft)
      this.$refs.table1.clearCheckboxRow() // 清空已选择
      this.checkedleft = []
    },
    handleConcatArr(selectArr, nowSelectData) {
      let arr = []
      arr = arr.concat(nowSelectData, selectArr)
      return arr
    },
    // 将经销商数据加到左边
    putDealerDataToLeft() {
      this.handleRemoveTabList(this.rcheckedleft, this.dealerAddDialogSelectedDealerList)
      this.$refs.table2.clearCheckboxRow() // 清空已选择
      this.rcheckedleft = []
    },
    handleRemoveTabList(checkArr, originalArr) {
      for (const item of checkArr) {
        // 已保存的经销商不移除
        if (this.modelTableBase.data.some(i => i.id && i.dealerId === item.dealerId)) { continue }
        if (originalArr.indexOf(item) > -1) {
          this.$nextTick(() => {
            originalArr.splice(originalArr.indexOf(item), 1)
          })
        }
      }
    },
    // 添加经销商对话框关闭前，需要清空列表
    handleDealerAddDialogBeforeClose() {
      this.dealerAddDialogSelectedDealerList = []
      this.dealerAddDialogAllDealerList = []
      this.dealerAddDialogVisible = false
    },
    submitDistributorSelect() {
      // 设置初始值，，防止无法绑定
      this.dealerAddDialogSelectedDealerList.forEach(v => {
        if (!v.feeLimit) v.feeLimit = null
        if (!v.writeRate) v.writeRate = null
        if (!v.executeFreq) v.executeFreq = null
      })
      this.modelTableBase.data = JSON.parse(JSON.stringify(this.dealerAddDialogSelectedDealerList))
      this.slicePlanDealers()
      this.dealerAddDialogSelectedDealerList = []
      this.dealerAddDialogAllDealerList = []
      this.dealerAddDialogVisible = false
    },
    // 分页
    slicePlanDealers() {
      this.modelTableBase.loading = true
      this.pagination.total = this.modelTableBase.data.length
      this.pageSelectedDealers = this.modelTableBase.data.slice((this.pagination.current - 1) * this.pagination.size, this.pagination.current * this.pagination.size)
      this.modelTableBase.loading = false
    },
    handleClearDataInDealerAddDialog() {
      this.base.sectorId = null
      this.base.provinceId = null
      this.base.cityId = null
      this.base.dealerName = null
      this.handleQueryByPageInDealerAddDialog(1)
    },
    handleQueryByPageInDealerAddDialog(n) {
      this.dealerAddPageDataSearchLoading = true
      const param = {
        page: n,
        limit: 1000,
        ...this.base
      }
      findDealerList(param).then(res => {
        if (res.code === 1 && res.data) {
          this.dealerAddPageDataSearchLoading = false
          this.dealerAddDialogAllDealerList = res.data.list
        }
      })
    },
    // 保存下发活动的经销商
    addAndUpdateBatchActplanDealer(type) {
      const data = {
        planId: this.activity.id,
        dealers: this.modelTableBase.data
      }
      saveBatchInDetails(data).then(res => {
        if (res.code === 1) {
          // type为0，则是保存，type为1则是发布
          if (type === 0){
            this.$message.success('保存成功')
            // 重新加载当前页
            this.$refreshPage(this.$route.fullPath)
          } else if (type === 1) {
            this.submint()
          }
        } else {
          this.$message.error(res.message)
        }
      }).catch(() => {
        // 超时、网络错误、500 等都会进这里
        this.$message.error('请求异常，请稍后重试')
      }).finally(() => {
        // 不管成功失败，都关掉 loading
        this.loading = false
      })
    },
    // 选择参与的经销商
    handleDealerSelectionChange(val) {
      this.dealerSelectedList = val.records
    },
    editExecuteFreqDialog() {
      // 先判断是否有已选择的经销商
      if (this.dealerSelectedList == null || this.dealerSelectedList.length <= 0) {
        this.$message.warning("请先选择要修改的经销商")
      } else {
        if (this.dealerSelectedList.some(d => !d.id)) {
          this.$message.warning('未保存的经销商不可批量编辑')
          return
        } else {
          // 弹出编辑框
          this.editExecuteFreqVisible = true
        }
      }
    },
    editBatchExecuteFreq() {
      if (this.newExecuteFreq > 0){
        // 赋值新的执行频率
        this.dealerSelectedList.forEach(d => { d.executeFreq = this.newExecuteFreq });
        // 调用接口更新
        this.editBatchExecuteFreqLoading = true
        batchUpdateExecuteFreq(this.dealerSelectedList).then(res => {
          this.editBatchExecuteFreqLoading = false
          if (res.code === 1) {
            this.$message.success('修改成功')
            this.editExecuteFreqVisible = false
            this.queryByPageActDb()
          } else if (res.code === 2) {
            this.$message.warning(res.message)
            this.editExecuteFreqVisible = false
            this.queryByPageActDb()
          } else {
            this.$message.error(res.message)
          }
        })
      } else {
        this.$message.warning("执行频次要大于0")
      }
    }
  }
}
</script>
<style lang="less" scoped>
.CertificateReleaseApplicationBox {
  width: 100%;
  overflow: auto;
  padding: 0 5px;
  .elcolSpan {
    font-size: 12px;
    color: #606266;
    text-align: center;
  }
  .budgetBox {
    margin: 0 0 5px 0;
    .select-form {
      /deep/ .ant-form-item {
        display: flex;
        margin-right: 10px;
      }
    }
  }
}

.a-input__inner {
  color: #4d4d4d;
}
.fixedButton {
  // padding: 0px 5px 0px;
  margin: 0 0 5px 0;
  border-bottom: 1px solid rgb(201, 201, 201);
  .examineButton {
    margin: 5px;
  }
}
.item-line {
  margin: 0;
  padding: 0px 20px;
  width: 100%;
  // margin-left: 2%;
  background: #0a76a4;
  color: #ffffff;
  height: 30px;
  line-height: 30px;
}
.bodyBox {
  // margin: 0 34px;
}
.usereq {
  .a-row {
    margin: 5px 0 !important;
  }
  .grid-content,
  .grid-Prohibit {
    text-align: center;
    font-size: 16px;
    border-radius: 4px;
    min-height: 36px;
  }
  .grid-content .el-checkbox__label {
    font-size: 16px;
  }
  .left_content {
    height: 80%;
    padding: 0 10px 10px 10px;
    overflow-y: auto;
    border-radius: 5px;
  }
  .center_content {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
  }
  .a-select.a-input--small .a-input__inner {
    color: #616b80;
    width: 100%;
    background: #152841;
    border-color: #152841;
    border-radius: 5px;
  }
  .el-checkbox-group .el-checkbox__label {
    display: none;
  }
  .center {
    text-align: center;
  }
  .center_content_r {
    width: 90%;
    height: 200px;
    margin-top: 200px;
  }
  .rule_btn {
    width: 100%;
    height: 60px;
    background: #28548e;
    float: left;
    border: none;
  }
  .rule_btn_left,
  .rule_btn_right {
    background: #1074f6;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 3px;
  }
  .rule_btn_left img {
    transform: rotate(180deg);
  }
  .rule_btn_left:hover,
  .rule_btn_right:hover {
    background: #1e3a5f;
  }
}
.a-input.is-disabled .a-input__inner {
  color: #6a6a6a;
}
.el-textarea.is-disabled .el-textarea__inner {
  color: #6a6a6a;
}
.sourceSelect .a-input .a-select__caret.a-input__icon::before {
  content: '';
}
.footer-btn-box {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 10px;
}
.move-btn-container {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 450px;
}
.err-box {
  margin-top: 10px;
}
</style>
